import AnswerMultipleSubQuestionYesNoChoices from './AnswerMultipleSubQuestionYesNoChoices';

export default AnswerMultipleSubQuestionYesNoChoices;
